<script setup>
import constants from "@/constants/constants";
import {ref, watch, inject} from "vue";
import Avatar from "@/components/ui/Avatar.vue";

defineProps(['task'])
const emit = defineEmits(['showTask', 'selected']);

const selectAll = inject('selectAll');
const deSelectAll = inject('deSelectAll');
const selected = ref(false);

watch(selectAll, (value) => {
    if (value) {
        selected.value = true;
    }
});

watch(deSelectAll, (value) => {
    if (value) {
        selected.value = false;
    }
});

watch(selected, (value) => {
    emit('selected', value);
});
</script>

<template>
    <tr style="cursor: pointer" @click="emit('showTask')" :key="task.id">
        <td class="main-table__check" @click.stop>
            <div class="input-checkbox">
                <input :id="`t-${task.id}`" v-model="selected" type="checkbox">
                <label :for="`t-${task.id}`"/>
            </div>
        </td>
        <td>
            <figure v-if="task.assignee" class="main-table__user">
                <Avatar
                    :title="task.assignee.name"
                    class="mr-3"
                    :username="task.assignee.name"
                    :src="task.assignee.avatar"
                    :size="33"
                />

                <figcaption>{{ task.title }}</figcaption>
            </figure>
        </td>
        <td>
            <a v-if="task.comments_count" href="#" class="link link--chat">{{ task.comments_count }}</a>
        </td>
        <td>
            <span class="priority-note" :class="`priority-note--${task.priority}`">{{constants.tasksPriorities[task.priority]}}</span>
        </td>
        <td>
            <span class="status-badge" :class="`status-badge--${task.status}`">
                {{ constants.tasksStatus[task.status] }}
            </span>
        </td>
        <td>
            <span
                v-if="task.reporter"
                :class="{deleted: task.reporter.deleted}"
            >
                {{task.reporter.name}}
            </span>
        </td>
        <td>
            {{task.due_date}}
        </td>
        <td>
            <a v-if="task.startup" :href="`/startups/${task.startup.id}`" target="_blank" class="link">
                {{task.startup.name}}
            </a>
        </td>
        <td class="main-table__empty-col"></td>
    </tr>
</template>

<style scoped>

</style>
